import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
export function ExpectedResultContainer({ label, value }) {
    return (_jsxs(Stack, { p: 2, ml: { sm: 5, lg: 8, xl: 8 }, px: 6, bgcolor: 'white', border: 1, borderColor: '#B3B3B3', alignItems: 'center', children: [_jsx(Typography, { fontSize: 14, fontWeight: 400, children: label }), _jsx(Typography, { fontSize: 32, fontWeight: 600, children: value })] }));
}
